import { render, staticRenderFns } from "./AccountStoreBlackListPop.vue?vue&type=template&id=56bf3e6c&"
import script from "./AccountStoreBlackListPop.vue?vue&type=script&lang=js&"
export * from "./AccountStoreBlackListPop.vue?vue&type=script&lang=js&"
import style0 from "./AccountStoreBlackListPop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports